<div id="safety-macro-page"></div>